import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../services/authentication.service';
import { HttpclientService } from '../../services/httpclient.service';
import { CookieService } from 'ngx-cookie-service';
import { Enablesaveuseraccessdto } from '../../model/enablesaveuseraccessdto';
import { DatasharingService } from '../../services/datasharing.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  username : string;
  password : string;
  invalidLogin = false;
  unauthenticationuser = "";
  cookieusername : string;
  cookiepassword : string;
  forgetpassword : boolean =false;
  loading : boolean;
  forgotPasswordMessage : Enablesaveuseraccessdto;
  forgotemailmsg : string = "";
  isSession;
  constructor(private router: Router,
              private loginservice: AuthenticationService, private httpclientService : HttpclientService,private cookieService: CookieService, private datasharing : DatasharingService) {
                sessionStorage.setItem('userid','');
              }

  ngOnInit() {
    this.checkingrememberme();
  }
  checkingrememberme(){
    let iscookieusername = this.cookieService.get('username');
    let iscookiepassword = this.cookieService.get('password');
    if(iscookieusername != null && iscookieusername !=undefined && iscookieusername != "" && iscookiepassword != null && iscookiepassword !=undefined && iscookiepassword !=""){
      this.username = iscookieusername;
      this.password = iscookiepassword;
    }

  }
  checkLogin() {
    if(this.username == "" || this.password ==""){
      this.unauthenticationuser = 'Invalid Email Address and/or Password';
      return;
    }
    this.datasharing.isVisibleSource.next(this.username);

    (this.loginservice.authenticate(this.username, this.password).subscribe(
      data => {
        this.router.navigate(['dashboard']);
        sessionStorage.setItem('username', this.username);
        sessionStorage.setItem('password', this.password);
        this.invalidLogin = false;
      },
      error => {
        console.log('...' + error);
        this.invalidLogin = true;
        this.unauthenticationuser = 'Invalid Email Address and/or Password';
      }
    )
    );
    this.httpclientService.getUserDetails(this.username, this.password);
  }
  rememberme(event){
    if(this.username==null || this.username==undefined || this.username==""){
      return;
    }if(this.password == null || this.password == undefined || this.password == "" ){
      return;
    }

      if ( event.target.checked ) {
        this.cookieService.set( 'username', this.username );
        this.cookieService.set( 'password', this.password );
        this.cookieusername = this.cookieService.get('username');
        this.cookiepassword = this.cookieService.get('password');
     }else{
      this.cookieService.delete( 'username' );
      this.cookieService.delete( 'password' );
      this.username="";
      this.password="";
     }


  }
  enablingforgotpassword(){
    this.forgetpassword = true;
    this.forgotemailmsg="";

  }
  clearemailaddress(){
    this.forgotemailmsg="";
  }
  forgotpassword(username){
    console.log("here >>  "+username);
    if(username == "" || username == undefined || username == null){
      this.forgotemailmsg="Please Enter Email Address";
      return;
    }
    if(!username.includes("@")){
      this.forgotemailmsg="Please Enter Email Address In Proper Format";
      return;
    }
    if(!username.includes(".")){
      this.forgotemailmsg="Please Enter Email Address In Proper Format";
      return;
    }
    if(username.includes(".") && username.includes("@")){
     var pos1  =  username.lastIndexOf("@")+3;
      var pos2 = username.lastIndexOf(".")
      if(pos2 < pos1){
      this.forgotemailmsg="Please Enter Email Address In Proper Format";
      return;
      }
    }

    this.loading = true;
    this.loginservice.forgotpassword(username).subscribe(
      data => {
        this.loading = false;
        this.forgotemailmsg = data.isEmailAddressExists;


      }
    )
  }
  clearunauthentiontext(){
    this.unauthenticationuser="";
  }
  cancelforgotpassword(){
    this.unauthenticationuser="";
    this.forgetpassword=false;

  }
}
